/**
 * @file PaddleHub 首页支持交流
 * @author FengGuang(fengguang01@baidu.com)
 */

interface ISupportCommunicationData {
    title: string;
    text: string;
    link?: string;
    onClick?: () => any;
    target?: string;
    tagText: string;
}

const supportCommunicationData: ISupportCommunicationData[] = [
    {
        title: '技术社区',
        text: '在这里，您可以了解PaddleHub开发者的工作内容并且有效交流学习',
        link: 'https://github.com/PaddlePaddle/PaddleHub',
        tagText: '进入社区'
    },
    {
        title: '贡献模型',
        text: '在这里，您可以上传自己的预训练模型，一起构建完善深度学习场景生态',
        link: 'https://github.com/PaddlePaddle/PaddleHub/blob/release/v2.0/docs/docs_ch/contribution/contri_pretrained_model.md',
        tagText: '点击上传'
    },
    {
        title: 'FAQ',
        text: '在这里，您可以获取更多在安装、使用PaddleHub过程中遇到的常见问题',
        link: 'https://github.com/PaddlePaddle/PaddleHub/wiki/PaddleHub-FAQ',
        tagText: '查看详情'
    }
];

export default supportCommunicationData;
